
export default {
  props: {
    // 接受父组件传递的值，用来控制图形验证的加载
    isGeet: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 310
    },
    product: {
      type: String,
      default: 'popup'
    }
  },
  data() {
    return {
      isPopGeet: false
    }
  },
  watch: {
    // 监听参数的变化，调用极验
    isGeet(newV) {
      if (!newV || this.isPopGeet) return false
      this.$nextTick(() => {
        this.isPopGeet = true
        const that = this
        setTimeout(() => {
          that.isPopGeet = false
        }, 1500)
        this.gtCaptcha()
        this.$refs.btn.click() // 这里通过按钮事件调用极验
      })
    }
  },
  methods: {
    updateIsGeet() {
      this.gtCaptcha()
    },
    async gtCaptcha() {
      const { succeed = false, result = {} } = await this.$api.home.userPhone({
        clienttype: 'web'
      })
      if (succeed) this.initvify(result)
    },
    initvify(data = {}) {
      const that = this
      const lang = this.$store.state.LanguageCode
      const { gt = '', challenge = '', success = true } = data
      this.$initGeet(
        {
          gt,
          challenge,
          offline: !success,
          new_captcha: data.new_captcha,
          lang,
          product: this.product,
          width: `${this.width}px`,
          api_server: 'api.geetest.com'
        },
        (captchaObj) => {
          this.geetest = captchaObj
          if (this.product == 'popup') captchaObj.appendTo('#huakuai')
          captchaObj
            .onReady(() => {
              // 验证码ready之后才能调用verify方法显示验证码(可以显示窗口了)
              if (this.product == 'bind') captchaObj.verify() // 显示验证码窗口
              captchaObj.onClose(function () {
                // 用户把验证关闭了，这时你可以提示用户需要把验证通过后才能进行后续流程
                that.$emit('closeGeet')
              })
            })
            .onSuccess(() => {
              this.isPopGeet = false
              this.$emit('geetPath', captchaObj.getValidate())
            })
            .onError(() => {
              this.isPopGeet = false
              this.$emit('geetError')
              console.log('极验错误')
              captchaObj.destroy()
            })
        }
      )
    }
  }
}
